import { render, staticRenderFns } from "./Thought.vue?vue&type=template&id=62778cf6&scoped=true"
import script from "./Thought.vue?vue&type=script&lang=js"
export * from "./Thought.vue?vue&type=script&lang=js"
import style0 from "./Thought.vue?vue&type=style&index=0&id=62778cf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5a36e3d9a1016b548fda15b2542a0eed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62778cf6",
  null
  
)

export default component.exports